import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AddAdminPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Navigate to admins page and trigger the add admin dialog
    if (user?.username) {
      navigate(`/admin/${user.username}/admins?openAddAdminDialog=true`);
    }
  }, [navigate, user]);
  
  return null; // This component doesn't render anything
};

export default AddAdminPage;
